import * as React from "react";
import classnames from "classnames";
import { SelectionBoxRadio } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                    */
const CLRxableSelect = ({ className, items, selectedValue, onChange }) => {
  return /* @__PURE__ */ React.createElement("fieldset", { className: classnames("cl-rxable-select", className) }, items.map(({ value, label }) => {
    return /* @__PURE__ */ React.createElement(
      SelectionBoxRadio,
      {
        key: value,
        name: "rxable-select",
        className: "cl-rxable-select__option",
        value,
        checked: selectedValue === value,
        onChange: () => onChange(value),
        "data-t": value
      },
      /* @__PURE__ */ React.createElement(Text, { className: "cl-rxable-select__option-text", variant: "body-head" }, label)
    );
  }));
};
export {
  CLRxableSelect
};
//# sourceMappingURL=CLRxableSelect.js.map
